import { BackendPermissionsType } from "./permission.types";
import { getProfile } from "./profileHelpers";

type IntegratedApplicationsType = {
  [key: string]: boolean | undefined;
};

export const PERMISSIONS = {
  MANAGE_EVENTS: "manageEvents",
  MANAGE_EVENT_BASES: "manageEventBases",
  MANAGE_ENROLLMENTS: "manageEnrollments",
  MANAGE_ATTENDEES: "manageAttendees",
  MANAGE_INTERESTS: "manageInterests",
  MANAGE_LECTURERS: "manageLecturers",
  MANAGE_TODOS_AND_RESPONSIBILITIES: "manageTodosAndResponsibilities",
  MANAGE_BOOKINGS: "manageBookings",
  MANAGE_INVOICES: "manageInvoices",
  MANAGE_MOODLE: "manageMoodle",
  MANAGE_SETTINGS: "manageSettings",
  MANAGE_TEMPLATES: "manageTemplates",
  MANAGE_BASE_DATA: "manageBaseData",
  MANAGE_ACCESS: "manageAccess",
  VIEW_ACCOUNTING: "viewAccounting",
  VIEW_REPORTING: "viewReporting",
  VIEW_BOOKING_LIST: "viewBookingList",
  VIEW_INVOICE_LIST: "viewInvoiceList",
  MANAGE_ACCOUNTING: "manageAccounting",
  MANAGE_EVENT_FEEDBACK: "manageEventFeedback",
  VIEW_FEEDBACK_REPORT: "viewFeedbackReport",
  MANAGE_ORGANIZATIONS: "manageOrganizations",
} as const;

export function isIntegratedApplicationActive(slug: "lexware" | "scopevisio" | "moodle"): boolean {
  const integratedApplicationsJSON = localStorage.getItem("integratedapplications");

  if (!integratedApplicationsJSON) return false;

  const integratedApplications = JSON.parse(integratedApplicationsJSON) as IntegratedApplicationsType;

  return !!integratedApplications[slug];
}

export function isExternalAccountingActive(): boolean {
  return isIntegratedApplicationActive("scopevisio") || isIntegratedApplicationActive("lexware");
}

export function moodleIsActive() {
  const profile = getProfile();
  return isIntegratedApplicationActive("moodle") && !!profile && profile.hasMoodleAuth;
}

export const hasPermissionGroup = (permissions: BackendPermissionsType) => (permissionOrPermissionGroup: string) => {
  const { isSuperuser = false, groups = [], custom = [] } = permissions;

  return isSuperuser || groups.includes(permissionOrPermissionGroup) || custom.includes(permissionOrPermissionGroup);
};

export function manageEmailingSenders() {
  const permissionsString = localStorage.getItem("permissions");

  const permissions: BackendPermissionsType | null = permissionsString
    ? (JSON.parse(permissionsString) as BackendPermissionsType)
    : null;

  if (permissions && permissions.isSuperuser) {
    return true;
  }

  return localStorage.getItem("manageEmailingSenders") === "true";
}
